<div id="auth-wrapper">
    <!-- <mat-toolbar>
        <img class="fg-logo" src="assets/img/logo.png" [alt]="logoDescription ? logoDescription : 'logo'">
       
    </mat-toolbar> -->

    <div class="auth-content-container">
        <div class="auth-card-wrapper">
            <div class="auth-card-container">
                <router-outlet>
                    <!-- Add Content Here -->
                    <ng-content></ng-content>
                </router-outlet>
            </div>
        </div>
    </div>

    <!-- footer -->
    <app-footer></app-footer>
</div>